(ns practitest.frontend.global-fields-settings.confirmation-modal
  (:require
    [practitest.frontend.components.icons :as icons]
     [practitest.frontend.components.modal :as modal]
     [practitest.frontend.components.spinners :as spinners]
     [practitest.frontend.components2.buttons :as buttons]
     [practitest.frontend.common.dom :as dom]))

(defn delete-confirmation-modal [{:keys [show? show-footer? title body on-delete on-cancel confirmation-button-text
                                          cancel-button-text modal-class show-icon? icon header-class destructive?
                                          saving? dialog-test-id confirm-test-id]}]
  [:<>
   [modal/bootstrap-modal
    {:class (dom/append-class "global-delete-modal" modal-class)
     :is-open? @show?
     :on-request-close (when (not saving?) on-cancel)
     :close-button? true
     :centered? true
     :footer-class "justify-content-center"
     :title-class "justify-content-center"
     :test-id dialog-test-id}
    ;;Header
     [:<>
      (when (not (false? show-icon?))
        (or icon [icons/mux-notification-error]))
      [:p {:class header-class} title]]
    ;;Body
     [:div.delete-modal-body body]
    ;;Footer
     (when show-footer?
       [:<>
         (when cancel-button-text
           [buttons/button {:size "large"
                            :disabled? saving?
                            :on-click on-cancel
                            :text cancel-button-text}])
         [buttons/button {:primary? true
                          :danger? destructive?
                          :size "large"
                          :disabled? saving?
                          :icon (when saving? [spinners/inline-spinner-border])
                          :on-click on-delete
                          :test-id confirm-test-id
                          :text confirmation-button-text}]])]])